import React from "react";
import ModalWindow from "../Shared/ModalWindow";
import BootstrapTable from "@partseye/react-bootstrap-table-next";
import ComponentLoading from "../Shared/ComponentLoading";
import "moment-timezone";
import DownloadOption from "../Shared/DownloadOption";
import { getSymbolByCurrencyCode, formatCurrencyAmount } from "../Shared/culture";

export default class StockOrderWithHistoryModal extends React.Component {

    constructor (props) {

        super(props);

        this.state = {
            "stockOrderWithHistory": [],
            "dataError": false,
            "loaded": false,
            isQuantityAvailableEnabled: false,
        };

    }

    getStockOrderWithHistory () {

        fetch(`api/PageContent/GetStockOrderWithHistory/${this.props.inventoryPK}/${this.props.orderTypePK}`).
            then((response) => response.json()).
            then((data) => {

                this.setState({
                    "stockOrderWithHistory": data,
                    "loaded": true
                });

            }).
            catch((error) => {

                this.setState({
                    "dataError": true
                });

            });

    }

    print () {

        this.setState({"printing": true});

        // Getting divs to be used
        const maindiv = document.getElementById("stock-order"),
            modal = document.getElementById("stockOrderWithHistory"),
            cloned = modal.cloneNode(true);

        // Hiding main reports div so it does not show up in modal print
        maindiv.style.visibility = "hidden";
        maindiv.style.display = "none";

        // Cloning model div and showing it on screen
        const section = document.createElement("div");
        section.id = "stockOrderWithHistory-print";
        document.body.appendChild(section);
        section.innerHTML = "";
        section.appendChild(cloned);
        setTimeout(
            () => {

                window.print();
                this.setState({"printing": false});

                // Un-hiding main reports div
                maindiv.style.visibility = "";
                $("#stock-order").css({"display": ""});
                $("#stockOrderWithHistory-print").remove();

            },
            500
        );
    }

    componentDidMount() {
        fetch("/api/user/GetSelectedInventory")
            .then((response) => response.json())
            .then((selectedInventory) => {
                this.setState({
                    isQuantityAvailableEnabled: selectedInventory.optUseAvailableToGenerateOrder
                });
            })
            .catch(console.error);
    }

    componentDidUpdate () {
        // if modal is not open, skip
        if (!this.props.printWithHistory) {
            return;
        }

        if (!this.state.loaded) {
            this.getStockOrderWithHistory();
        } else if (this.state.loaded && this.props.isStockOrderUpdated) {
            this.getStockOrderWithHistory();
            this.props.onStockOrderWithHistoryRefreshed();
        }
    }

    render () {
        let modalBody = "";
        let tableData = this.state.stockOrderWithHistory; 
        let modalTitle = this.props.pageText.stockOrderWithHistoryTitle;

        if (tableData === null || tableData.length <= 0) {

            modalBody = <ComponentLoading />;

        }
        else {
            let cleanedTableData = tableData;

            const moment = require("moment");
            let months = [],
                monthNames = moment.monthsShort(),
                today = new Date(),
                d,
                month,
                orderTotal = 0;

            for (var i = 0; i < 12; i += 1) {

                d = new Date(
                    today.getFullYear(),
                    today.getMonth() - i,
                    1
                );
                month = monthNames[d.getMonth()];
                months.push(month);

            }

            const tableColumns = [
                {
                    "dataField": "partNumber",
                    "text": "Part",
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "description",
                    "text": "Description",
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "bin",
                    "text": "Bin",
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "quantityOnHand",
                    "text": "OH",
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "quantityOnOrder",
                    "text": "OO",
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "quantitySuggested",
                    "text": "Qty",
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "price",
                    "text": "Price",
                    "sort": true,
                    headerClasses: 'headerFixed',
                    "formatter": (val) => (val === null ? "" : formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true))
                },
                {
                    "dataField": "amount",
                    "text": "Amount",
                    "sort": true,
                    headerClasses: 'headerFixed',
                    "formatter": (val) => (val === null ? "" : formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true))
                },
                {
                    "dataField": "averageLastSixMonths",
                    "text": "Avg6",
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month0",
                    "text": months[0],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month1",
                    "text": months[1],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month2",
                    "text": months[2],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month3",
                    "text": months[3],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month4",
                    "text": months[4],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month5",
                    "text": months[5],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month6",
                    "text": months[6],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month7",
                    "text": months[7],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month8",
                    "text": months[8],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month9",
                    "text": months[9],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month10",
                    "text": months[10],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
                {
                    "dataField": "month11",
                    "text": months[11],
                    "sort": true,
                    headerClasses: 'headerFixed'
                },
            ];

            if (this.state.isQuantityAvailableEnabled) {
                tableColumns.push({
                    "dataField": "quantityAvailable",
                    "text": "QA",
                    "sort": true,
                    headerClasses: 'headerFixed'
                });               
            } else {
                cleanedTableData = tableData.map(({ quantityAvailable, ...otherProperties }) => (otherProperties));
            }

            const defaultSorted = [
                {
                    "dataField": "partNumber",
                    "order": "asc"
                }
            ];
            const selected = this.props.sessionInfo.selected,
                currencySymbol = getSymbolByCurrencyCode(selected, true),
                showDecimal = selected.OptDisplayCurrencyDecimal === true,
                CSVData = cleanedTableData.map(i => ({
                    ...i,
                    price: (i.price === null ? "" : formatCurrencyAmount(i.price, selected, true, true)),
                    amount: (i.amount === null ? "" : formatCurrencyAmount(i.amount, selected, true, true))
                }));


            for (var i = 0; i < tableData.length; i++) {

                orderTotal += tableData[i].amount;

            }

            modalBody =

                (
                <div className="printable" id="stockOrderWithHistory">
                    <div id="StockOrderWithHistory-Printable" >
                        <div className="row text-center">
                            <div className="col-sm-12">
                                <p>
{this.props.pageText.stockOrderWithHistoryInstructions01}
</p>
                                <p>
{this.props.pageText.stockOrderWithHistoryInstructions02}
</p>
                            </div>
                        </div>
                        <div className="row text-center">
                                <div className="col-sm-12">
                                <p>
Reference: {tableData[0].reference}
&nbsp;&nbsp;&nbsp;{this.props.pageText.stockOrderOrderTotalText.replace(/\$/g, "") + formatCurrencyAmount(orderTotal, selected, true, true)}</p>
                            </div>
                        </div>
                        <div className="row text-right">
                            <div className="col-sm-12">
                                <DownloadOption
                                    action="StockOrderWithHistoryToExcel"
                                    columns={tableColumns}
                                    ExcelData={cleanedTableData}
                                    CSVData={CSVData}
                                    currencySymbol={currencySymbol}
                                    showDecimal={showDecimal}
                                    fileName={this.props.pageText.stockOrderWithHistory}
                                    id="stock-order-with-history"
                                    tooltip={this.props.pageText.downloadFileButton}
                                />

                                <i className="material-icons print text-right"
onClick={() => this.print()}>
print
</i>
                            </div>
                        </div>
                
                        <BootstrapTable
                            bootstrap4
                            columns={tableColumns}
                            condensed
                            data={cleanedTableData}
                            defaultSorted={defaultSorted}
                            headerClasses="thead-light"
                            keyField='partNumber'
                            striped />
                    </div>
                </div>);

        }
        return (
            <ModalWindow
                modalBody={modalBody}
                modalId="stockOrderWithHistoryModal"
                modalSize="modal-lg"
                modalTitle={modalTitle}
                onModalClose={this.props.onHide}
                />
        );

    }

}
